/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReturnFromCoupangConfirmReceiveAddressVo
 */
export interface ReturnFromCoupangConfirmReceiveAddressVo {
    /**
     * 收件人姓名
     * @type {string}
     * @memberof ReturnFromCoupangConfirmReceiveAddressVo
     */
    name?: string;
    /**
     * 联系方式
     * @type {string}
     * @memberof ReturnFromCoupangConfirmReceiveAddressVo
     */
    mobileNo?: string;
    /**
     * 收件人邮编
     * @type {string}
     * @memberof ReturnFromCoupangConfirmReceiveAddressVo
     */
    zip?: string;
    /**
     * 收件人地址
     * @type {string}
     * @memberof ReturnFromCoupangConfirmReceiveAddressVo
     */
    address?: string;
    /**
     * 收件人详细地址
     * @type {string}
     * @memberof ReturnFromCoupangConfirmReceiveAddressVo
     */
    addressDetail?: string;
}

/**
 * Check if a given object implements the ReturnFromCoupangConfirmReceiveAddressVo interface.
 */
export function instanceOfReturnFromCoupangConfirmReceiveAddressVo(value: object): value is ReturnFromCoupangConfirmReceiveAddressVo {
    return true;
}

export function ReturnFromCoupangConfirmReceiveAddressVoFromJSON(json: any): ReturnFromCoupangConfirmReceiveAddressVo {
    return ReturnFromCoupangConfirmReceiveAddressVoFromJSONTyped(json, false);
}

export function ReturnFromCoupangConfirmReceiveAddressVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnFromCoupangConfirmReceiveAddressVo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
    };
}

export function ReturnFromCoupangConfirmReceiveAddressVoToJSON(json: any): ReturnFromCoupangConfirmReceiveAddressVo {
    return ReturnFromCoupangConfirmReceiveAddressVoToJSONTyped(json, false);
}

export function ReturnFromCoupangConfirmReceiveAddressVoToJSONTyped(value?: ReturnFromCoupangConfirmReceiveAddressVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'mobileNo': value['mobileNo'],
        'zip': value['zip'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
    };
}

